const regexConfig = {
  email: "^[a-zA-Z0-9]{1}[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$",
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,20}$/,
  // "^(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$"
  name: /^(?!\s+$)[a-zA-Z,'. -]+$/,
  phone:
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  ValidNumber: "^[0-9]*$",
};

export default regexConfig;
